module.exports = ".trainingContainer {\n    margin-left: 251px;\n    font-size: 12px;\n    color: #4b4a4a;\n    height: calc(100% - 20px);\n}\n.selectedNodeTrainingTree {\n    font-weight: bold;\n    font-size: 13px;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/training/training.component.css
// module id = ./src/app/view/training/training.component.css
// module chunks = main